declare var google: any;

export class KontaktDiamentComponent {
    initiated: boolean = false;

    constructor() {
        setTimeout(this.initMap, 500);
    }

    initMap() {
        $.getScript('https://maps.googleapis.com/maps/api/js?key=AIzaSyAHmnSXsVL47USPaZyqVs90Hu2bCsa6KVo', () => {
            if (typeof google != 'undefined') {
                if (!this.initiated) {
                    this.initiated = true;
                    var wW = $(window).innerWidth();
                    var mPos = 0;
                    if (wW < 755) {
                        mPos = 0;
                    } else {
                        mPos = 0.008991;
                    }
                    var markerLatLng = {lat: 54.378284, lng: 18.605771900000036};
                    var mapLatLng = {lat: 54.378284, lng: 18.605771900000036 - mPos};
                    var map = new google.maps.Map(document.getElementById('map-container'), {
                        center: mapLatLng,
                        scrollwheel: false,
                        zoom: 15,
                        styles: [{
                            "featureType": "all",
                            "elementType": "geometry.fill",
                            "stylers": [{"weight": "2.00"}]
                        }, {
                            "featureType": "all",
                            "elementType": "geometry.stroke",
                            "stylers": [{"color": "#9c9c9c"}]
                        }, {
                            "featureType": "all",
                            "elementType": "labels.text",
                            "stylers": [{"visibility": "on"}]
                        }, {
                            "featureType": "landscape",
                            "elementType": "all",
                            "stylers": [{"color": "#f2f2f2"}]
                        }, {
                            "featureType": "landscape",
                            "elementType": "geometry.fill",
                            "stylers": [{"color": "#ffffff"}]
                        }, {
                            "featureType": "landscape.man_made",
                            "elementType": "geometry.fill",
                            "stylers": [{"color": "#ffffff"}]
                        }, {
                            "featureType": "poi",
                            "elementType": "all",
                            "stylers": [{"visibility": "off"}]
                        }, {
                            "featureType": "road",
                            "elementType": "all",
                            "stylers": [{"saturation": -100}, {"lightness": 45}]
                        }, {
                            "featureType": "road",
                            "elementType": "geometry.fill",
                            "stylers": [{"color": "#eeeeee"}]
                        }, {
                            "featureType": "road",
                            "elementType": "labels.text.fill",
                            "stylers": [{"color": "#7b7b7b"}]
                        }, {
                            "featureType": "road",
                            "elementType": "labels.text.stroke",
                            "stylers": [{"color": "#ffffff"}]
                        }, {
                            "featureType": "road.highway",
                            "elementType": "all",
                            "stylers": [{"visibility": "simplified"}]
                        }, {
                            "featureType": "road.arterial",
                            "elementType": "labels.icon",
                            "stylers": [{"visibility": "off"}]
                        }, {
                            "featureType": "transit",
                            "elementType": "all",
                            "stylers": [{"visibility": "off"}]
                        }, {
                            "featureType": "water",
                            "elementType": "all",
                            "stylers": [{"color": "#46bcec"}, {"visibility": "on"}]
                        }, {
                            "featureType": "water",
                            "elementType": "geometry.fill",
                            "stylers": [{"color": "#c8d7d4"}]
                        }, {
                            "featureType": "water",
                            "elementType": "labels.text.fill",
                            "stylers": [{"color": "#070707"}]
                        }, {
                            "featureType": "water",
                            "elementType": "labels.text.stroke",
                            "stylers": [{"color": "#ffffff"}]
                        }],
                        zoomControlOptions: {
                            position: google.maps.ControlPosition.RIGHT_TOP
                        },
                        streetViewControlOptions: {
                            position: google.maps.ControlPosition.RIGHT_TOP
                        },
                    });
                    var marker = new google.maps.Marker({
                        map: map,
                        position: markerLatLng,
                        icon: '/img/custom/diament/map-icon.png'
                    });
                }
            }
        });
    }
}
